@if (IsThumbnail) {
  <!-- thumbnail: page 1 only, filling the host (P6 `.cx-thumb .cx-pg`) -->
  <div class="cx-thumb">
    @for (p of Pages; track p.Num) {
      <div class="cx-pg" [style.width.px]="p.Width" [style.height.px]="p.Height">
        <canvas [attr.data-page]="p.Num" [style.width.px]="p.Width" [style.height.px]="p.Height"></canvas>
      </div>
    }
  </div>
} @else {
  <div class="cx-viewer">
    <!-- P6:569-574 -->
    <div class="cx-vh">
      <span class="k">YOUR DOCUMENT</span>
      <button class="z" type="button" aria-label="Zoom out" (click)="ZoomBy(-1)">−</button>
      <span class="zp">{{ ZoomPercent }}%</span>
      <button class="z" type="button" aria-label="Zoom in" (click)="ZoomBy(1)">+</button>
      <span class="fn" [attr.title]="FileName">{{ FileName }}</span>
    </div>
    <!-- P6:575 -->
    <div class="cx-vb" #body tabindex="0" role="region" aria-label="Your CV">
      @if (Failed) {
        <p class="cx-vmsg">We could not show your document. You can still review the tags.</p>
      } @else if (Loading || !Url) {
        <p class="cx-vmsg">Loading your document…</p>
      }
      @for (p of Pages; track p.Num) {
        <div class="cx-pg" [style.width.px]="p.Width" [style.height.px]="p.Height">
          <canvas [attr.data-page]="p.Num" [style.width.px]="p.Width" [style.height.px]="p.Height"></canvas>
          @for (b of BoxesOn(p.Num); track $index) {
            <div class="cx-hl" aria-hidden="true"
                [style.left.px]="b.Css.left" [style.top.px]="b.Css.top" [style.width.px]="b.Css.width" [style.height.px]="b.Css.height"></div>
          }
        </div>
      }
    </div>
  </div>
}
